import React from 'react';

export const IconCheck = ({
  color = 'black',
}) => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="12.885" height="9.73" viewBox="0 0 12.885 9.73">
  <path id="Icon_metro-checkmark" data-name="Icon metro-checkmark" d="M12.9,3.784,6.28,10.4,3.125,7.25,1.571,8.8,6.28,13.514l8.175-8.175Z" transform="translate(-1.571 -3.784)" fill={color}/>
</svg>;
}